import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNavigate } from "react-router-dom";

const schema = yup.object().shape({
  NewPassword: yup
    .string()
    .required("New password is required")
    .min(4, "Password must be at least 4 characters long"),
  ConfirmPassword: yup
    .string()
    .oneOf([yup.ref("NewPassword"), null], "Passwords must match")
    .required("Confirm password is required"),
});

export default function ResetPassword({ open, handleClose, user }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (formData) => {
    setLoading(true);
    try {
      const userData = JSON.parse(localStorage.getItem("userData"));
      const response = await axios.post(
        `https://tarabotcs.com-eg.net/api/Users/V1/ResetPassword`,
        {
          UserID: user.UserID,
          NewPassword: formData.NewPassword,
          ConfirmPassword: formData.ConfirmPassword,
        },
        {
          headers: {
            CompanyID: userData.Data.CompanyID,
            AccessToken: userData.Data.AccessToken,
          },
        }
      );
      console.log("Password reset successfully", response.data);
      handleClose();
    } catch (error) {
      console.error("Error resetting password:", error);
      if (error.response && error.response.status === 401) {
        console.log("Session expired, logging out...");
        localStorage.removeItem("userData"); // Clear user data
        navigate("/"); // Redirect to the home page
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Reset Password</DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          <TextField
            margin="dense"
            label="New Password"
            name="NewPassword"
            type="password"
            {...register("NewPassword")}
            error={!!errors.NewPassword}
            helperText={errors.NewPassword?.message}
            fullWidth
          />
          <TextField
            margin="dense"
            label="Confirm Password"
            name="ConfirmPassword"
            {...register("ConfirmPassword")}
            error={!!errors.ConfirmPassword}
            helperText={errors.ConfirmPassword?.message}
            fullWidth
          />
        </DialogContent>
        <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            onClick={handleClose}
            sx={{ backgroundColor: "red", color: "white" }}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            sx={{ backgroundColor: "#263150", color: "white" }}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : "Change Password"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
